import { observer } from 'mobx-react';
import type { GroupInfo, ObjectBoxInfo, TuneControlInfo } from '@/engine/app/models/viewEntity/view.entity.ts';

import type { FC } from 'react';
import type { MeasurementBoxProps } from '@/components/boxes/measurementBoxes/MeasurementBoxesController/MeasurementBoxes.controller.ts';

import { usePlanningEntities } from './usePlanningEntities';
import { GroupLayout } from './GroupLayout';
import { EntityBox } from './EntityBox';
import { isGroupKind } from '@/components/contentContainers/entityValidators.ts';

export type FilledGroupInfo = GroupInfo & { entities: Array<PlanningEntity> };

export type PlanningEntity = ObjectBoxInfo | MeasurementBoxProps | TuneControlInfo;

export const PlanningContainer: FC = observer(() => {
  const entities = usePlanningEntities();

  return entities.map((entity) =>
    isGroupKind(entity) ? (
      <GroupLayout key={entity.label} title={entity.label} entities={entity.entities} isExpanded={entity.isExpanded} />
    ) : (
      <EntityBox key={entity.order} entity={entity} />
    )
  );
});
